// Components==============
import schoolIndex from 'actions/school/index';
import React, { createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// =========================

export const StoreContext = createContext(null);

export default function StoreContextWrapper({ children }) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(schoolIndex());
    }, []);

    const schoolGroups = useSelector((state) => state?.school?.entities);

    return (
        <StoreContext.Provider
            value={{
                schoolGroups: schoolGroups?.allIds.map(
                    (e) => schoolGroups?.byId[e]
                ),
            }}
        >
            {children}
        </StoreContext.Provider>
    );
}
